/**
 * @constructor
 * @param {number}                  index
 * @param {boolean}                 isHandle
 * @param {number}                  layerIndex
 * @param svgGroup
 * @param rotate
 * @param transform
 */
var GroupInfo = function (index, isHandle, layerIndex, svgGroup, transform, rotate) {
    this.index = index;
    this.isHandle = isHandle;
    this.layer = layerIndex;
    this.svgGroup = svgGroup;
    this.transform = transform;
    this.rotate = rotate;
};

module.exports = GroupInfo;

